<div *ngIf="!node.children">
  <a *ngIf="!node.divider" href="{{node.url}}" [ngClass]="classes" title="{{node.tooltipCn}}"
    class="vertical-menu-item" style="position: relative" [target]="isExternalUrl(node.url!!)?'_blank':'_self'">
    <span>{{node.titleCn ?? node.title}}</span>
    <mat-icon *ngIf="isExternalUrl(node.url!!)">open_in_new</mat-icon>
  </a>
  <div *ngIf="node.divider" class="mat-divider" style="margin: 4px 20px; border-top: 1px solid lightgray"></div>
</div>

<div *ngIf="node.children">
  <a *ngIf="!!node.url" href="{{node.url}}" [ngClass]="classes" title="{{node.tooltipCn}}"
    (click)="headerClicked()" class="vertical-menu-item heading">
    <span>{{node.titleCn ?? node.title}}</span>
    <mat-icon class="rotating-icon" svgIcon="keyboard_arrow_right"></mat-icon>
  </a>

  <button *ngIf="!node.url" type="button" [ngClass]="classes" title="{{node.tooltipCn}}"
    (click)="headerClicked()" class="vertical-menu-item heading"
    [attr.aria-pressed]="isExpanded">
    <span>{{node.titleCn ?? node.title}}</span>
    <mat-icon class="rotating-icon" svgIcon="keyboard_arrow_right"></mat-icon>
  </button>

  <div class="heading-children" [ngClass]="classes">
    <aio-nav-item *ngFor="let node of nodeChildren" [level]="level + 1" [isWide]="isWide"
    [isParentExpanded]="isExpanded"
    [node]="node" [selectedNodes]="selectedNodes"></aio-nav-item>
  </div>
</div>
